import { clsx } from 'clsx';
import { ComponentPropsWithRef } from 'react';
import { spinner } from './spinner.css.ts';

export type SpinnerProps = {
  size?: number;
} & ComponentPropsWithRef<'div'>;

export const Spinner = function SpinnerComponent({
  ref,
  className,
  size = 16,
  ...rest
}: SpinnerProps) {
  return (
    <div
      ref={ref}
      className={clsx(spinner, className)}
      style={{ width: size, height: size }}
      {...rest}
    />
  );
};
